import { Injectable } from '@angular/core';
import {Beneficiario} from "../shared/models/beneficiario.model";

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  beneficiario: Beneficiario;
  beneficiarioSelecionado: Beneficiario;

  visualizaListaSolicitacoes: boolean = false;
  visualizaBotaoSolicitacoes: boolean = false;
}
